/**
 * Device Storage API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AccelerationChannelOrientationConfiguration { 
    x?: AccelerationChannelOrientationConfiguration.XEnum;
    xreversed?: boolean;
    y?: AccelerationChannelOrientationConfiguration.YEnum;
    yreversed?: boolean;
    z?: AccelerationChannelOrientationConfiguration.ZEnum;
    zreversed?: boolean;
}
export namespace AccelerationChannelOrientationConfiguration {
    export const XEnum = {
        Channel1: 'CHANNEL_1',
        Channel2: 'CHANNEL_2',
        Channel3: 'CHANNEL_3'
    } as const;
    export type XEnum = typeof XEnum[keyof typeof XEnum];
    export const YEnum = {
        Channel1: 'CHANNEL_1',
        Channel2: 'CHANNEL_2',
        Channel3: 'CHANNEL_3'
    } as const;
    export type YEnum = typeof YEnum[keyof typeof YEnum];
    export const ZEnum = {
        Channel1: 'CHANNEL_1',
        Channel2: 'CHANNEL_2',
        Channel3: 'CHANNEL_3'
    } as const;
    export type ZEnum = typeof ZEnum[keyof typeof ZEnum];
}


export type XEnum = typeof AccelerationChannelOrientationConfiguration.XEnum[keyof typeof AccelerationChannelOrientationConfiguration.XEnum];
export type YEnum = typeof AccelerationChannelOrientationConfiguration.YEnum[keyof typeof AccelerationChannelOrientationConfiguration.YEnum];
export type ZEnum = typeof AccelerationChannelOrientationConfiguration.ZEnum[keyof typeof AccelerationChannelOrientationConfiguration.ZEnum];
